import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Image, Table, Button, Label, Icon } from 'semantic-ui-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const SHAREABLE_LINK = window.location.href;

class ReportHeader extends React.Component {
  state = {
    copied: false,
  }
  render = () => {
    const { info } = this.props;
    const { copied } = this.state;
    const generatedTime = moment().format('MMMM Do YYYY, h:mm a');

    return (
      <div>
        <Table fluid celled>
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan={2}>
                { info.hasLogo && <Image centered src="/images/afterparty-logo.png" alt="Afterparty Studios" height="100" /> }
                { info.logo && <Image centered src={info.logo.src} alt={info.logo.alt} height={info.logo.height} /> }
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell width={3}>CAMPAIGN</Table.Cell>
              <Table.Cell width={13}><h3>{ info.campaignName }</h3></Table.Cell>
            </Table.Row>
            { info.influencerName && <Table.Row>
              <Table.Cell>INFLUENCER</Table.Cell>
              <Table.Cell><h3>{ info.influencerName }</h3></Table.Cell>
              </Table.Row>
            }
            { info.reportDate && <Table.Row>
              <Table.Cell>REPORT DATE</Table.Cell>
              <Table.Cell><h3>{ moment(info.reportDate).format('MMMM Do YYYY') }</h3></Table.Cell>
              </Table.Row>
            }
            { info.reportType && <Table.Row>
              <Table.Cell>REPORT TYPE</Table.Cell>
              <Table.Cell><h3>{ info.reportType }</h3></Table.Cell>
              </Table.Row>
            }
            { info.campaignHashTag && <Table.Row>
              <Table.Cell>HASHTAGS etc</Table.Cell>
              <Table.Cell>
                <Label basic color="pink">{ info.campaignHashTag }</Label> - <Label basic color="pink">{ info.campaignSponsorHandle }</Label>
              </Table.Cell>
              </Table.Row>
            }
            <Table.Row>
              <Table.Cell>SHAREABLE LINK</Table.Cell>
              <Table.Cell>
                <a>{ SHAREABLE_LINK }</a>
                <CopyToClipboard
                  text={SHAREABLE_LINK}
                  onCopy={() => this.setState({ copied: true })}
                >
                  <span>&nbsp;&nbsp;<Button size="mini" color="green" basic icon="copy" content="copy link" /></span>
                </CopyToClipboard>
                { copied ? <Label><Icon name="thumbs outline up" />Copied...</Label> : null }
              </Table.Cell>
            </Table.Row>
            { !info.hasLogo &&
              <Table.Row>
                <Table.Cell>DATA <Icon name="clock" color="orange" /></Table.Cell>
                <Table.Cell>
                  <span>
                    Report generated at <strong>{ generatedTime }</strong>.
                  </span>
                  &nbsp;
                </Table.Cell>
              </Table.Row>
            }
          </Table.Body>
        </Table>
      </div>
    );
  }
}

ReportHeader.propTypes = {
  info: PropTypes.object.isRequired,
};

ReportHeader.defaultProps = {
  info: {
    hasLogo: true,
  },
};

export default ReportHeader;



// WEBPACK FOOTER //
// ./src/components/report-header/index.js